import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const StarredContactsZeroState5Icon = (props: IconProps) => (
  <Icon height="32px" width="32x" viewBox="0 0 32 32" {...props}>
    <rect width="32" height="32" fill="#E5F2FF" rx="16" />
    <mask id="a" width="32" height="32" x="0" y="0" maskUnits="userSpaceOnUse">
      <circle cx="16" cy="16" r="16" fill="#B94C24" />
    </mask>
    <g mask="url(#a)">
      <path fill="#A2E6F5" d="M-5.12-6.08h63.36V54.4H-5.12z" />
      <path
        fill="#1D9AD2"
        d="M14.66 30.027c-3.778.234-8.66-1.013-11.096 6.132-1.867 12.884-5.062 62.595-5.062 62.595l36.106.27s-1.483-43.765-6.002-62.874c-1.245-5.265-4.059-3.7-5.517-4.83-2.422-1.02-5.213-1.494-8.425-1.295l-.004.002Z"
      />
      <path
        fill="#1D9AD2"
        d="M9.493 41.062s-9.902-4.739-6.634-11.8c3.267-7.06 28.48-4.256 28.324 1.98-.156 6.235-12.294 10.654-12.294 10.654l-9.393-.834h-.003Z"
      />
      <path
        fill="#5B5B5B"
        d="M8.492 18.425s-1.366-4.598-.19-7.665c1.48-3.857 8.53-8.147 10.84-7.072 2.314 1.074-1.1 3.535-.048 3.841 1.052.306 1.69-2.142 2.393-1.688 2.843 1.834 1.003 11.493 1.003 11.493l-9.908-2.973-4.09 4.064Z"
      />
      <path
        fill="#F9C1AD"
        d="m19.467 31.31-3.398 3.238-3.401-3.237.597-7.336h5.605l.597 7.336Z"
      />
      <path
        fill="#F9C1AD"
        d="M21.707 15.243c-.388-3.476-3.442-5.438-6.902-5.052-3.458.387-6.01 2.975-5.622 6.449 0 0 .222 4.463.247 4.679.367 3.303 4.869 7.042 7.367 6.762 2.883-.322 5.978-5.72 5.7-8.22-.025-.216-.792-4.62-.792-4.62l.002.002Z"
      />
      <path
        fill="#F9C1AD"
        d="M9.587 17.467s-.857-.427-1.384.467c-.527.895.23 3.948 1.776 3.775 1.547-.172-.394-4.242-.394-4.242h.002ZM21.543 16.132s.742-.606 1.454.15c.71.758.644 3.901-.905 4.074-1.546.172-.55-4.224-.55-4.224Z"
      />
      <g clipPath="url(#b)">
        <path
          fill="#CEA23E"
          d="M30.362 33.912 8.68 37.507 44.29 56.498l-9.12-20.02a4.48 4.48 0 0 0-4.808-2.566Z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="b">
        <path
          fill="#fff"
          d="m13.764 19.343 42.735 22.79-22.754 42.803-42.735-22.79z"
        />
      </clipPath>
    </defs>
  </Icon>
);

export default memo(StarredContactsZeroState5Icon);
